import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import { SomedayMaybePage } from "./somedaymaybe/SomedayMaybePage";
import "semantic-ui-css/semantic.min.css";
import "react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css";
import { NewInputPage } from "./intray/InputPage";
import { TabPane, Tab, MenuItem } from "semantic-ui-react";
import { SettingsPage } from "./settings/SettingsPage";
import {
  GET_DEFAULT_PRIORITY,
  LIST_ORGANIZATIONS,
  LIST_PEOPLE,
  LIST_SETTINGS,
} from "./routes/queries";
import { LoginPage } from "./account/LoginModal";
import { getSession, useQueryWrapper } from "./helper";
import { Caches } from "./cache/Caches";
import { createContext, useState } from "react";
import { Tooltip } from "./tooltip";
import { SettingsCache } from "./cache/SettingsCache";
import { SocialNetwork } from "./social/SocialNetworkPage";
import { AISandbox } from "./ai_sandbox/AISandbox";
import { ReferenceLibrayPageTabMenu } from "./referencelibrary/ReferenceLibraryPage";
import { RoutinePage } from "./routine/RoutinePage";
import { NewProjectsPage } from "./projects/NewProjectsPage";
import { NewLifeDomainPage } from "./life_domain/NewLifeDomainPage";
import { NewNextActionPage } from "./nextaction/NewNextActionPage";
import { NewPageComponent } from "./components/page/NewPageComponent";
import { NewWaitingForPage } from "./waitingfor/NewWaitingForPage";

export const TooltipContext = createContext(false);

export const MainAppPage = () => {
  const navigate = useNavigate();
  const session = localStorage.getItem("second-brain-session");
  const [showTooltips, setShowTooltips] = useState(
    SettingsCache.getInstance().getShowTooltips(),
  );
  useQueryWrapper(LIST_SETTINGS, { session: getSession() }, (data) => {
    setShowTooltips(data.listSettings);
    SettingsCache.getInstance().setShowTooltips(data.listSettings);
  });
  useQueryWrapper(LIST_ORGANIZATIONS, { session: getSession() }, (data) =>
    Caches.getOrganizationCache().setElements(data.listOrganizations),
  );
  useQueryWrapper(LIST_PEOPLE, { session: getSession() }, (data) =>
    Caches.getPeopleCache().setElements(data.listPeople),
  );
  useQueryWrapper(GET_DEFAULT_PRIORITY, { session: getSession() }, (data) =>
    SettingsCache.getInstance().setDefaultPriority(data.getDefaultPriority),
  );

  if (session === undefined || session === null) {
    navigate("/login");
  }

  const updateSettingsCallback = (data: boolean) => {
    setShowTooltips(data);
  };

  const panes = [
    {
      menuItem: (
        <MenuItem>
          Input
          <Tooltip
            name="Input"
            message="Used for capturing anything that crosses your mind"
          />
        </MenuItem>
      ),
      render: () => (
        <TabPane id="input-tab">
          <NewInputPage />
        </TabPane>
      ),
    },
    {
      menuItem: (
        <MenuItem>
          Life Domains
          <Tooltip
            name="Life Domains"
            message="Areas of your life that you want to organize"
          />
        </MenuItem>
      ),
      render: () => (
        <TabPane id="life-domains-tab">
          <NewLifeDomainPage />
        </TabPane>
      ),
    },
    {
      menuItem: (
        <MenuItem>
          Next Actions
          <Tooltip name="Next Actions" message="Simple one-step tasks" />
        </MenuItem>
      ),
      render: () => (
        <TabPane id="next-actions-tab">
          <NewNextActionPage />
        </TabPane>
      ),
    },
    {
      menuItem: (
        <MenuItem>
          Reference Library
          <Tooltip
            name="Reference Library"
            message="Non-actionable items that you want to keep for future reference"
          />
        </MenuItem>
      ),
      render: () => (
        <TabPane id="reference-library-tab">
          <ReferenceLibrayPageTabMenu />
        </TabPane>
      ),
    },
    {
      menuItem: (
        <MenuItem>
          Someday/Maybe
          <Tooltip
            name="Someday/Maybe"
            message="Projects you are not working on right now, but may want to in the future"
          />
        </MenuItem>
      ),
      render: () => (
        <TabPane id="someday-maybe-tab">
          <SomedayMaybePage />
        </TabPane>
      ),
    },
    {
      menuItem: (
        <MenuItem>
          Waiting For
          <Tooltip
            name="Waiting For"
            message="Items that you are waiting for to be finished by someone else"
          />
        </MenuItem>
      ),
      render: () => (
        <TabPane id="waiting-for-tab">
          <NewWaitingForPage />
        </TabPane>
      ),
    },
    {
      menuItem: (
        <MenuItem>
          Projects
          <Tooltip
            name="Projects"
            message="Anything that requires multiple steps to complete"
          />
        </MenuItem>
      ),
      render: () => (
        <TabPane id="projects-tab">
          <NewProjectsPage />
        </TabPane>
      ),
    },
    {
      menuItem: (
        <MenuItem>
          Routines
          <Tooltip
            name="Routines"
            message="Things that you want to do repeatedly"
          />
        </MenuItem>
      ),
      render: () => (
        <TabPane>
          <NewPageComponent
            props={{
              type: "hardcoded_page",
              page: <RoutinePage />,
            }}
          />
        </TabPane>
      ),
    },
    {
      menuItem: (
        <MenuItem>
          Social Network
          <Tooltip
            name="Social Network"
            message="People and Organizations you interact with"
          />
        </MenuItem>
      ),
      render: () => (
        <TabPane id="social-network-tab">
          <SocialNetwork />
        </TabPane>
      ),
    },
    {
      menuItem: (
        <MenuItem>
          Settings
          <Tooltip name="Settings" message="Customize your Second Brain" />
        </MenuItem>
      ),
      render: () => (
        <TabPane id="settings-tab">
          <SettingsPage updateSettingsCallback={updateSettingsCallback} />
        </TabPane>
      ),
    },
  ];

  return (
    <div>
      <TooltipContext.Provider value={showTooltips}>
        <Tab panes={panes} />
      </TooltipContext.Provider>
    </div>
  );
};

const App = () => {
  return (
    <>
      {
        <Router>
          <Routes>
            <Route path="*" element={<MainAppPage />}></Route>
            <Route path="/login" element={<LoginPage />}></Route>
            <Route path="/ai_sandbox" element={<AISandbox />} />
          </Routes>
        </Router>
      }
    </>
  );
};
export default App;
